var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJquery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#1a1918}.st1{fill:#21609b}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "m417.2 214.7 15.3.1s-28.5 38.6-30.8 41.8c-.8 1-1.9 2.1-2.5 3.5-1.5 3.4-3 10.9-3 10.9l-14 .1s2.2-7.8 2.1-12c-.1-3.6-1.9-7.3-3-10.9-1.1-3.7-2.5-10.9-2.5-10.9h14.4l2 8z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_5_",
    d: "M388.2 222.8c2.8 1.7 4.6 11.1 4.6 11.1s-14.8.2-22.9.2h-7l-8.5 36.8h-12.9s8-40 9.9-47.2c.6-2.3 4.2-1.9 10.3-1.9h9.7c6.3-.1 13.7-.9 16.8 1",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_8_",
    d: "M328 240.7s.4-2.4-1.4-5.1c-1.5-2.3-2.9-2.9-6.9-3-11.2-.4-11 8-11 8zm12.2-9.5c1.6 5.9-1.5 19.9-1.5 19.9s-16.4-.3-25.4 0c-2.8.1-6.1-.3-7 1-1.2 1.8.4 4.6 1.8 5.8 1.6 1.4 4.6 1.5 5.7 1.7 7.3.9 22.5.2 22.5.2l-2.6 11.7s-21.5 1.1-32.3-1.5c-2.1-.5-4.1-1.5-5.5-3-.4-.4-.7-.9-1-1.4-.3-.4-1.1-1.6-1.5-2.6-2.5-6.6.3-19.1 3-25.8.3-.8.7-1.8 1.1-2.6.5-1 1-2.2 1.4-2.9.3-.4.6-.7.9-1.1.3-.5.7-.9 1.1-1.4 1-1.2 2.1-2 3.5-3 4.5-3.4 12.6-6 22.4-5 3.7.4 9.2 1.7 11.9 5.5.7 1 1.1 3 1.5 4.5",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_9_",
    d: "m280.9 221.7 12.5-.1s-7 33.1-10.5 49.3h-14.4c-10.1 0-19 1.2-22.9-6-3.7-7-.2-18.5 1.5-26.3 1.2-5.5 3.6-16.9 3.6-16.9l13-.1s-3.7 17.6-5.2 26.4c-.5 3.2-1.7 6.1-.5 8.5 1.1 2.2 2.7 2.4 7.5 2.5h6.5z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_12_",
    d: "M222.2 245.6c1.3-4.7 3.2-9.7 3-13.9-.3-4.5-4-8.6-6.5-9.4-7.3-2.6-14.2 1-16.9 4-3.5 3.8-4.7 8.3-6 14.4-.9 4.6-1.7 9.4 0 12.9 3 6.3 12.3 4.9 22.4 5 1.5-4.1 2.8-8.6 4-13m17.4-18.4c1.4 10.4-4.1 21.9-7.8 31.9 3.9.3 7.2-.1 7.5.2.3.4-2.6 11.9-3.6 12-3.1.1-13.2.2-17.4.2-13.8 0-26.7.9-33.3-6-2.7-2.8-4.5-7.6-5-10.9-.7-5.6.2-11.8 1.5-16.9 1.2-4.6 2.7-8.9 5-12.9 5.8-10.1 15.9-17.6 32.8-15.9 3.3.3 8 1.8 10.9 3.5.2.1.9.7 1.1.8 3.9 2.4 7.6 8.4 8.3 14",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_13_",
    d: "M178.5 221.8c-.8 3.8-1.7 8.1-2.6 11.9H162c1.1-4.2 1.9-8.3 3-11.9 4.5-.1 8.7 0 13.5 0",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_14_",
    d: "M161.6 237.1H175c-1.8 9.7-5.2 25.4-8 36.3-1.7 6.8-2.8 11.8-7.5 15.4-.4.3-.7.2-1 .5-.9.8-4.8 1.8-7 2-3.5.4-7.5 0-11.9 0 1.1-4.2 2.4-9.2 3.4-12.9 10.6 1.3 10.9-8.7 12.9-18.4 1.4-5.6 5-20.7 5.7-22.9",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_15_",
    d: "m130.3 262.5-.3.7c-4.9 9.5-13.6 15.4-26 15.7-5.8.1-11.3-1.4-14.9-3-7.8-3.5-14.3-10-17.9-16.9-5.1-9.9-6-23.7 4.6-34.1.2 0-1.3 2.2-1.1 2.2l-.3 1c-7.7 24 16 44.6 39 42.3 5.5-.6 12.5-3.6 16.9-7.9",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_16_",
    d: "M116.3 252.5c5.8 0 11.8-2.7 15.4-6.5-3.1 7.9-12.2 13.1-24.4 11.4-10.2-1.4-19.9-11.6-20.9-21.9-.7-7.5 1.9-11.9 6.2-17.3-1.5 2.8-2 5-2.2 6.4-1.5 16.2 13 27.8 25.9 27.9",
    className: "st1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_17_",
    d: "M131.2 232.4c-.9 2.1-6.1 6-8.4 6.4-9.1 1.9-14.9-2.4-17.9-7.3-.5-.7-1.3-2.7-1.4-3.2-1.2-4-.6-10.1 2.9-13.2-1.1 3-1.2 6.4-.7 8.7.3 1.4 1.4 3.7 2.4 5.2 1.9 2.7 3.1 3.4 5.5 4.8 1.1.7 2.2 1.2 2.7 1.3 2.3.9 7.1 2.6 14.9-2.7",
    className: "st1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJquery);
export default __webpack_public_path__ + "static/media/jquery.f779b01fa4b25f9d18586e13700bb335.svg";
export { ForwardRef as ReactComponent };